// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_format from "../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function convertKmsToMeters(distance) {
  return distance * 1000.0 | 0;
}

var AllocationDashboardUtils = {
  convertKmsToMeters: convertKmsToMeters
};

function getInitialValueForFormInput(value) {
  if (value !== undefined) {
    return String(value);
  }
  
}

function convertFilterValuesFromKilometersToMeters(value) {
  var distance = Belt_Option.getExn(value);
  return distance * 1000.0 | 0;
}

function convertTimestampToHours(time) {
  if (time !== undefined) {
    return new Date(Timestamp$Catalyst.toFloat(Caml_option.valFromOption(time))).getHours() | 0;
  }
  
}

function convertTimestampToMinutes(time) {
  if (time !== undefined) {
    return new Date(Timestamp$Catalyst.toFloat(Caml_option.valFromOption(time))).getMinutes() | 0;
  }
  
}

function getFilterValueOrDefault(value) {
  if (value !== undefined) {
    return value;
  } else {
    return -1;
  }
}

function adjustTimeWithDate(date, time) {
  if (date === undefined) {
    if (time !== undefined) {
      return Caml_option.some(Caml_option.valFromOption(time));
    } else {
      return ;
    }
  }
  if (time === undefined) {
    return ;
  }
  var valueDate = Caml_option.valFromOption(date);
  var start_time = new Date(Timestamp$Catalyst.toFloat(Caml_option.valFromOption(time)));
  var fullYear = valueDate.getFullYear();
  var month = valueDate.getMonth();
  var day = valueDate.getDate();
  var hour = start_time.getHours();
  var mins = start_time.getMinutes();
  return Caml_option.some(Timestamp$Catalyst.make(Date.parse(new Date(fullYear, month, day, hour, mins).toString())));
}

var CreateZonalOrClusterCampaigns = {
  getInitialValueForFormInput: getInitialValueForFormInput,
  convertFilterValuesFromKilometersToMeters: convertFilterValuesFromKilometersToMeters,
  convertTimestampToHours: convertTimestampToHours,
  convertTimestampToMinutes: convertTimestampToMinutes,
  getFilterValueOrDefault: getFilterValueOrDefault,
  adjustTimeWithDate: adjustTimeWithDate
};

function getDeltaValue(campaign_filter_value, active_mandatory_campaign_filter_value) {
  return campaign_filter_value - active_mandatory_campaign_filter_value;
}

function toFixedDecimalPoint(value, decimalPoint) {
  return Caml_format.caml_float_of_string(value.toFixed(decimalPoint));
}

var PreviewZonalOrClusterCampaigns = {
  getDeltaValue: getDeltaValue,
  toFixedDecimalPoint: toFixedDecimalPoint
};

function getDataLostWarningModalData(onCancel, onSubmit) {
  return {
          isOpen: true,
          onCancel: onCancel,
          onSubmit: onSubmit,
          title: "Unsaved Priorities",
          confirm_button_title: "Leave This Page",
          cancel_button_title: "Stay On This Page",
          modal_body: "You have not submitted the changes and it will be lost if you leave this page. Are you sure, you wish to leave this page?"
        };
}

function getWarningBeforeSubmissionOnPriorityChange(onCancel, onSubmit) {
  return {
          isOpen: true,
          onCancel: onCancel,
          onSubmit: onSubmit,
          title: "Update Priorities",
          confirm_button_title: "Yes, Proceed",
          cancel_button_title: "No, Cancel",
          modal_body: "You are about to update priority order of Pending priorities. Are you sure, you wish to continue?"
        };
}

function getWarningBeforeSubmissionOnStatusChange(onCancel, onSubmit) {
  return {
          isOpen: true,
          onCancel: onCancel,
          onSubmit: onSubmit,
          title: "Update Campaign Status",
          confirm_button_title: "Yes, Proceed",
          cancel_button_title: "No, Cancel",
          modal_body: "You are about to update status of campaigns. Are you sure, you wish to continue?"
        };
}

function getWarningForLateCampaignApproval(onCancel, onSubmit, message) {
  return {
          isOpen: true,
          onCancel: onCancel,
          onSubmit: onSubmit,
          title: "Update Start Date",
          confirm_button_title: "Yes, Proceed",
          cancel_button_title: "No, Cancel",
          modal_body: message
        };
}

var Modals = {
  getDataLostWarningModalData: getDataLostWarningModalData,
  getWarningBeforeSubmissionOnPriorityChange: getWarningBeforeSubmissionOnPriorityChange,
  getWarningBeforeSubmissionOnStatusChange: getWarningBeforeSubmissionOnStatusChange,
  getWarningForLateCampaignApproval: getWarningForLateCampaignApproval
};

export {
  AllocationDashboardUtils ,
  CreateZonalOrClusterCampaigns ,
  PreviewZonalOrClusterCampaigns ,
  Modals ,
  
}
/* Timestamp-Catalyst Not a pure module */
